import { LOGIN_ERRORS } from "../../../../constants";

// Helper function to handle form error state
const getLoginFormError = (error: string) => {
  switch (true) {
    case error.includes(LOGIN_ERRORS.INVALID_CREDENTIALS.apiResponse):
      return LOGIN_ERRORS.INVALID_CREDENTIALS.userErrorMessage;
    case error.includes(LOGIN_ERRORS.MAX_ATTEMPTS.apiResponse):
      return LOGIN_ERRORS.MAX_ATTEMPTS.userErrorMessage;
    default:
      return LOGIN_ERRORS.DEFAULT.userErrorMessage;
  }
};

export default getLoginFormError;
